import { render, staticRenderFns } from "./SubjectEdit.vue?vue&type=template&id=81c7e97c"
import script from "../../../controllers/custom/subject/subject-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/subject/subject-edit.js?vue&type=script&lang=js&external"
import style0 from "./SubjectEdit.vue?vue&type=style&index=0&id=81c7e97c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports